<!-- BEGIN: Horizontal Menu -->
<div ktOffcanvas [options]="offcanvasOptions" [class]="menuWrapperStyle" id="kt_header_menu_wrapper">
    <div [class]="containerClass">
        <div
            id="kt_header_menu"
            ktMenu
            [options]="menuOptions"
            class="header-menu header-menu-left header-menu-mobile header-menu-layout-default"
        >
            <ul class="menu-nav">
                @if (isMobileDevice()) {
                    <li class="menu-item menu-item-here menu-item-submenu" aria-haspopup="true">
                        <menu-search-bar></menu-search-bar>
                    </li>
                }
                @for (item of menu.items; track item) {
                    @if (item.name) {
                        <ng-container
                            [ngTemplateOutlet]="kt_menu"
                            [ngTemplateOutletContext]="{ item: item, depth: 0 }"
                        ></ng-container>
                    }
                }
                @if (!isMobileDevice()) {
                    <li class="menu-item menu-item-here menu-item-submenu" aria-haspopup="true">
                        <menu-search-bar></menu-search-bar>
                    </li>
                }
            </ul>
        </div>
    </div>
</div>
<!-- END: Horizontal Menu -->

<ng-template #kt_menu let-item="item" let-parentItem="parentItem" let-depth="depth">
    @if (showMenuItem(item)) {
        <li
            aria-haspopup="true"
            data-menu-toggle="click"
            class="{{ getItemCssClasses(item, parentItem, depth) }}"
            routerLinkActive="menu-item-active"
        >
            <!-- if item has submenu -->
            @if (item.items.length) {
                <a href="javascript:;" class="{{ getAnchorItemCssClasses(item, parentItem) }}">
                    <ng-container
                        [ngTemplateOutlet]="kt_menu_item_inner"
                        [ngTemplateOutletContext]="{ item: item, parentItem: parentItem, depth: depth + 1 }"
                    ></ng-container>
                    @if (item.items.length && !parentItem) {
                        <i class="menu-hor-arrow la la-angle-down ml-2 mt-2"></i>
                    }
                    @if (item.items.length && parentItem) {
                        <i class="menu-ver-arrow la la-angle-right"></i>
                    }
                </a>
            }
            <!-- if item hasn't sumbenu -->
            @if (!item.items.length) {
                @if (!item.external) {
                    <a [routerLink]="item.route" [queryParams]="item.parameters" class="menu-link">
                        <ng-container
                            [ngTemplateOutlet]="kt_menu_item_inner"
                            [ngTemplateOutletContext]="{ item: item, parentItem: parentItem, depth: depth + 1 }"
                        ></ng-container>
                    </a>
                }
                @if (item.external) {
                    <a [attr.href]="[item.route]" target="_blank" class="menu-link">
                        <ng-container
                            [ngTemplateOutlet]="kt_menu_item_inner"
                            [ngTemplateOutletContext]="{ item: item, parentItem: parentItem, depth: depth + 1 }"
                        ></ng-container>
                    </a>
                }
            }
            <!-- if menu item has submenu child then recursively call new menu item component -->
            @if (item.items.length) {
                <div class="{{ getSubmenuCssClasses(item, parentItem, depth) }}">
                    <span class="menu-arrow" [ngClass]="{ 'menu-arrow-adjust': !parentItem }"></span>
                    @if (item.items.length) {
                        <ul class="menu-subnav">
                            @for (child of item.items; track child) {
                                <ng-container
                                    [ngTemplateOutlet]="kt_menu"
                                    [ngTemplateOutletContext]="{ item: child, parentItem: item, depth: depth + 1 }"
                                ></ng-container>
                            }
                        </ul>
                    }
                </div>
            }
        </li>
    }
</ng-template>

<!-- item inner -->
<ng-template #kt_menu_item_inner let-item="item" let-parentItem="parentItem">
    <!-- if menu item has icon -->
    @if (item.icon) {
        <i class="menu-link-icon mr-2" [ngClass]="item.icon"></i>
    }

    <ng-container>
        <span class="menu-item-here"></span>
        <!-- menu item title text -->
        <span class="menu-text">
            {{ item.name | localize }}
        </span>
    </ng-container>
</ng-template>
